import Link from 'next/link'
import Image from 'next/image'
import { BookmarkIcon } from '@heroicons/react/24/outline'
import networkTestingThumbnail from '/public/courses/network-testing.png'
import pluginsThumbnail from '/public/courses/cypress-plugins.png'
import swagStoreThumbnail from '/public/courses/swag.png'
import cyVsPwThumbnail from '/public/courses/cy-vs-pw.png'
import splitThumbnail from '/public/courses/cypress-split.png'
import cyCopilotThumbnail from '/public/courses/cy-copilot.png'
import visualTestingThumbnail from '/public/courses/visual-testing.png'
// https://undraw.co/ calculator image #FFC963 accent color
import tddCalculatorThumbnail from '/public/courses/tdd-calculator.png'
// https://undraw.co/ Teaching image #63B9FF accent color
import fundamentalsThumbnail from '/public/courses/teaching.png'
// Artificial intelligence accent color "#17B8A6"
import cursorThumbnail from '/public/courses/cypress-cursor.png'
import styles from './CourseSummary.module.css'

function EnrollLink({ url }) {
  return (
    <a
      href={url}
      title="Pay for the course and enroll"
      className={`${styles.enrollLink}`}
      data-cy="enroll"
    >
      Enroll in this course
    </a>
  )
}

const courseThumbnailsBySlug = {
  cyv10: fundamentalsThumbnail,
  'network-testing': networkTestingThumbnail,
  'cypress-plugins': pluginsThumbnail,
  'swag-store': swagStoreThumbnail,
  'cypress-vs-playwright': cyVsPwThumbnail,
  'cypress-split': splitThumbnail,
  'cy-copilot': cyCopilotThumbnail,
  'visual-testing': visualTestingThumbnail,
  'tdd-calculator': tddCalculatorThumbnail,
  'cy-cursor': cursorThumbnail,
}

function CourseSummary(props) {
  // console.log(props)
  const { course } = props
  // console.log(course.meta)

  const slug = course?.slug || course?.meta?.slug
  if (!slug) {
    throw new Error(`Missing slug for course ${course.id}`)
  }
  const thumbnail = courseThumbnailsBySlug[slug] || pluginsThumbnail

  const courseUrl = course?.meta?.url || `/courses/${slug}`
  const showConvince = course?.meta?.showConvince || false
  const hasInterviewKit = course?.meta?.hasInterviewKit || false
  const stripePaymentLink = course?.meta?.stripePaymentLink
  const priceMessage = course?.meta?.priceMessage
  const priceDollars = course?.meta?.priceDollars || 'free'
  const published = course?.meta?.published
  const tags = (course?.meta?.tags || '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean)

  // title showing if the user is enrolled or not
  let title
  if (typeof course.enrolled === 'string') {
    title = course.enrolled
  } else {
    title = course.enrolled
      ? 'Enrolled'
      : course.complete
      ? 'Completed'
      : 'Not enrolled'
  }

  const showEnrolled =
    'showEnrolled' in course.meta ? course.meta.shouldEnroll : true
  const shouldEnroll = !course.enrolled
  const hasEnroll =
    process.env.NEXT_PUBLIC_STRIPE_ENABLE === 'true' && stripePaymentLink

  // console.log({ priceDollars })

  return (
    <section
      key={course.id}
      className={styles.summary}
      data-cy="course-summary"
      data-price={priceDollars}
    >
      <div className={styles.summaryInside}>
        <div className={styles.summaryTitle}>
          <h2>
            <Link
              className="no-underline cursor-pointer"
              href={courseUrl}
              data-cy="course-link"
            >
              {course.title}
            </Link>
          </h2>
          <div className={styles.summaryStatus} title={title}>
            <span className={styles.summaryTags} data-cy="course-tags">
              {tags.join(', ')}
            </span>
            {showEnrolled && (
              <BookmarkIcon
                className={course.enrolled ? styles.iconEnrolled : ''}
              />
            )}
          </div>
        </div>
        <div className={styles.courseDescriptionContainer}>
          <p className={styles.courseDescription}>
            {/* <Link
            className="no-underline cursor-pointer"
            to={'/courses/' + slug}
          > */}
            {course.meta.description}
            {/* </Link> */}
          </p>
          <Image src={thumbnail} alt="Course thumbnail" />
          {/* <details>
          <summary>See more details</summary>
          {course.meta.description}

        </details> */}
        </div>
        <div className={styles.courseDescriptionContainer}>
          <div className={styles.published}>{published}</div>

          {course.enrolled ? (
            <div data-cy="already-enrolled" className={styles.prices}>
              You are already enrolled in this course 🧑‍🎓
            </div>
          ) : (
            <>
              {priceMessage ? (
                <div className={styles.prices}>{priceMessage}</div>
              ) : (
                <div className={styles.prices}>
                  Course price is{' '}
                  <span className={styles.price} data-cy="price">
                    ${priceDollars}
                  </span>
                  , group discounts are{' '}
                  <Link href="/network-course#discounts">available</Link>
                  {shouldEnroll && hasEnroll && (
                    <EnrollLink url={stripePaymentLink} />
                  )}
                </div>
              )}
            </>
          )}
        </div>

        {(showConvince || hasInterviewKit) && (
          <div className={styles.centerParent}>
            <div className={styles.convinceList}>
              {showConvince && (
                <div className={styles.convince}>
                  Looking to convince your company to buy this course? Send
                  them&nbsp;
                  <Link
                    className="no-underline cursor-pointer"
                    href="/network-course"
                  >
                    this link
                  </Link>
                  .
                </div>
              )}
              {hasInterviewKit && (
                <div className={styles.convince}>
                  Conducting test automation interviews covering this topic?
                  Purchase my{' '}
                  <Link href="/network-course#interview-kit">
                    interview kit
                  </Link>{' '}
                  based on this course.
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </section>
  )
}

export default CourseSummary
